import React from 'react';

interface TextViewerProps {
  url: string;
}

const TextViewer: React.FC<TextViewerProps> = ({ url }) => {
  return (
    <div style={{ 
      width: '100vw', 
      height: '100vh', 
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <iframe
        src={url}
        style={{
          width: '100%',
          height: '100%',
          border: 'none'
        }}
        title="Text Viewer"
      />
    </div>
  );
};

export default TextViewer;
